import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPDesktopGalleryRevamp from '../PDPDesktopGalleryRevamp';
import { PDPDesktopGalleryHoldFallback } from '../PDPDesktopPhotoPanel';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPNameSection from '../PDPNameSection';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPAvailableInSizes from '../PDPAvailableInSizes';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPGalleryLabels from '../PDPGalleryLabels';
import PDPDecideLaterButton from '../PDPDecideLaterButton';
import PDPInfoTabs from '../PDPInfoTabs';
import PDPStickySummaryBar from '../PDPStickySummaryBar';
import PDPSectionDivider from '../PDPSectionDivider';
import PDPCuralateGallery from '../PDPFooter/PDPCuralateGallery';
import { PDPRecentlyViewed } from '../PDPFooter';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));

/**
 * Desktop layout for the CON-8777 test variant: PDPDesktop's components in the
 * new order. BYO and edit-order stay on PDPDesktop. The variant is designed
 * on top of the redesigned gallery, so it renders that directly rather than
 * going through PDPDesktopPhotoPanel's gallery-flag branch.
 */
const PDPDesktopRevamp = t0 => {
  const $ = _c(67);
  const {
    discontinuedCategoryMsg: t1,
    isOutOfStock: t2,
    showDiscontinuedNotification: t3,
    showOutOfStockNotification: t4,
    slug,
    productHeroImage: t5,
    productCylindoHeroImage: t6
  } = t0;
  const discontinuedCategoryMsg = t1 === undefined ? null : t1;
  const isOutOfStock = t2 === undefined ? false : t2;
  const showDiscontinuedNotification = t3 === undefined ? false : t3;
  let t7;
  if ($[0] !== t4) {
    t7 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const showOutOfStockNotification = t7;
  const productHeroImage = t5 === undefined ? null : t5;
  const productCylindoHeroImage = t6 === undefined ? null : t6;
  const isBrowser = useIsBrowser();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  let t8;
  if ($[2] !== productCylindoHeroImage || $[3] !== slug) {
    t8 = <PDPStickySummaryBar slug={slug} productCylindoHeroImage={productCylindoHeroImage} />;
    $[2] = productCylindoHeroImage;
    $[3] = slug;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t10;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="mt-10 -mb-8"><PDPGalleryLabels /></div>;
    t10 = <PDPNameSection disableStickyPriceRow={true} hideProductLabel={true} hideRatings={true} />;
    $[5] = t10;
    $[6] = t9;
  } else {
    t10 = $[5];
    t9 = $[6];
  }
  let t11;
  if ($[7] !== isBrowser) {
    t11 = isBrowser ? <PDPAvailableInSizes /> : <div className="PDPDesktop__PDPAvailableInSizes-filler" />;
    $[7] = isBrowser;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  let t12;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <PDPOnDisplayInShowroom />;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== discontinuedCategoryMsg || $[11] !== showDiscontinuedNotification) {
    t13 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPDesktop__PDPAlertBar-filler" />;
    $[10] = discontinuedCategoryMsg;
    $[11] = showDiscontinuedNotification;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== isOutOfStock || $[14] !== showDiscontinuedNotification) {
    t14 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPDesktop__in-stock-options"><PDPShopTabsBar hideDecideLaterTab={true} isLayoutRevamp={true} /><PDPDecideLaterButton /><PDPChooseYourOptions isLayoutRevamp={true} /></div> : <div className="PDPDesktop__in-stock-options-filler" />;
    $[13] = isOutOfStock;
    $[14] = showDiscontinuedNotification;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== isOutOfStock || $[17] !== showDiscontinuedNotification || $[18] !== showOutOfStockNotification) {
    t15 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPDesktop__PDPAlertSection-filler" />;
    $[16] = isOutOfStock;
    $[17] = showDiscontinuedNotification;
    $[18] = showOutOfStockNotification;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== showDiscontinuedNotification) {
    t16 = !showDiscontinuedNotification && <hr className="border-0 border-t border-gray-light7 my-6" />;
    $[20] = showDiscontinuedNotification;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== isOutOfStock) {
    t17 = <PDPAddToBagSection isOutOfStock={isOutOfStock} isLayoutRevamp={true} />;
    $[22] = isOutOfStock;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== isOutOfStock || $[25] !== showDiscontinuedNotification) {
    t18 = !isOutOfStock && !showDiscontinuedNotification ? <><PDPUpSellProduct isLayoutRevamp={true} /><PDPProtectionPlanSelector isLayoutRevamp={true} /></> : <div className="PDPDesktopRevamp__add-ons-filler" />;
    $[24] = isOutOfStock;
    $[25] = showDiscontinuedNotification;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t11 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15 || $[31] !== t16 || $[32] !== t17 || $[33] !== t18) {
    t19 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]">{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}</div>;
    $[27] = t11;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="min-h-[66px]"><PDPBreadCrumbs /></div>;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <PDPDesktopGalleryHoldFallback tag="panel" />;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <PDPDesktopGalleryHoldFallback tag="revamp" />;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== productCylindoHeroImage || $[39] !== productHeroImage || $[40] !== slug) {
    t23 = <SuspenseWithLoader fallback={t22}><PDPDesktopGalleryRevamp slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} hideProductLabel={true} /></SuspenseWithLoader>;
    $[38] = productCylindoHeroImage;
    $[39] = productHeroImage;
    $[40] = slug;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <SuspenseWithLoader fallback={<PDPDesktopGalleryHoldFallback tag="ksp" />}><PDPKeySellingPoints /></SuspenseWithLoader>;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t23) {
    t25 = <SuspenseWithLoader fallback={t21}>{t23}{t24}</SuspenseWithLoader>;
    $[43] = t23;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <PDPInfoTabs />;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t25) {
    t27 = <div className="flex-1 mr-12 min-w-0">{t20}{t25}{t26}</div>;
    $[46] = t25;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== t19 || $[49] !== t27) {
    t28 = <FixedWidthContainer wide={true} className="flex flex-row-reverse !pt-2 !pb-8">{t19}{t27}</FixedWidthContainer>;
    $[48] = t19;
    $[49] = t27;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== displayPressComp) {
    t29 = !displayPressComp ? <><PDPSectionDivider className="my-12" /><SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} isLayoutRevamp={true} /></SuspenseWithLoader></> : <div className="PDPDesktop__PDPPress-filler" />;
    $[51] = displayPressComp;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  let t31;
  let t32;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <PDPSectionDivider className="my-12" />;
    t31 = <PDPCuralateGallery isLayoutRevamp={true} />;
    t32 = <PDPSectionDivider className="my-12" />;
    $[53] = t30;
    $[54] = t31;
    $[55] = t32;
  } else {
    t30 = $[53];
    t31 = $[54];
    t32 = $[55];
  }
  let t33;
  if ($[56] !== slug) {
    t33 = <PDPCustomerPhotos slug={slug} isLayoutRevamp={true} />;
    $[56] = slug;
    $[57] = t33;
  } else {
    t33 = $[57];
  }
  let t34;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <PDPSectionDivider className="my-12" />;
    $[58] = t34;
  } else {
    t34 = $[58];
  }
  let t35;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <SuspenseWithLoader><PDPRecentlyViewed isLayoutRevamp={true} /></SuspenseWithLoader>;
    $[59] = t35;
  } else {
    t35 = $[59];
  }
  let t36;
  if ($[60] !== t29 || $[61] !== t33) {
    t36 = <FixedWidthContainer wide={true} className="!pt-0 !pb-8">{t29}{t30}{t31}{t32}{t33}{t34}{t35}</FixedWidthContainer>;
    $[60] = t29;
    $[61] = t33;
    $[62] = t36;
  } else {
    t36 = $[62];
  }
  let t37;
  if ($[63] !== t28 || $[64] !== t36 || $[65] !== t8) {
    t37 = <div className="max-[1023px]:hidden" data-xc="PDPDesktopRevamp">{t8}{t28}{t36}</div>;
    $[63] = t28;
    $[64] = t36;
    $[65] = t8;
    $[66] = t37;
  } else {
    t37 = $[66];
  }
  return t37;
};
PDPDesktopRevamp.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  isOutOfStock: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPDesktopRevamp;